
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2BDialog extends Serenity.EntityDialog<B2BRow, any> {
        protected getFormKey() { return B2BForm.formKey; }
        protected getIdProperty() { return B2BRow.idProperty; }
        protected getLocalTextPrefix() { return B2BRow.localTextPrefix; }
        protected getNameProperty() { return B2BRow.nameProperty; }
        protected getService() { return B2BService.baseUrl; }
        protected getDeletePermission() { return B2BRow.deletePermission; }
        protected getInsertPermission() { return B2BRow.insertPermission; }
        protected getUpdatePermission() { return B2BRow.updatePermission; }

        protected form = new B2BForm(this.idPrefix);

    }
}